import React, { useState, useEffect } from 'react';
import TicketServices from '../../services/TicketServices';

function TicketPriority({ data, page, onSuccess }) {
  const [selectedSequence, setSelectedSequence] = useState(data.priority || "Low");

  useEffect(() => {
    setSelectedSequence(data.priority || "Low");
  }, [data]);

  const handleSequenceChange = async (event) => {
    const newSequence = event.target.value;
    setSelectedSequence(newSequence);
    try {
      await TicketServices.updateTicket(data._id, {
        priority: newSequence,
      });
      onSuccess();
    } catch (error) {
      console.error('Failed to update Ticket priority', error);
      // Handle error accordingly, e.g., show an alert or notification
    }
  };

  return (
    <div class="status-dropdown">
    <select
      className= " "
      value={selectedSequence}
      onChange={handleSequenceChange}
      style={{
        backgroundColor:
          selectedSequence === "Low" ? '#699836' :
          selectedSequence === "Medium" ? '#F9B842' :
          selectedSequence === "High" ? '#FF3333' : 'white'
      }}
    >
       
      <option value="Low" style={{ backgroundColor : '#699836'}} >LOW</option>
      <option value="Medium" style={{ backgroundColor : '#F9B842'}} >MEDIUM</option>
      <option value="High" style={{ backgroundColor : '#FF3333'}} >HIGH</option>
      {/* <option value="rejected">Rejected</option> */}
    </select>
    </div>
  );
}

export default TicketPriority;